import { Reducer } from "redux";
import { ITransferState, IVendorState } from "../../interfaces/IState";
import { ITransfer } from "../../interfaces/ITransfer";
import { Dictionary } from "../../types";
import {
  TRANSFER_CLEAR,
  TRANSFER_FETCH_EMPTY,
  TRANSFER_FETCH_FULFILLED,
  TRANSFER_FETCH_PENDING,
  TRANSFER_FETCH_REJECTED,
  TRANSFER_MODAL_CLOSE,
  TRANSFER_MODAL_OPEN
} from "../../utils/constants";
import { defaultSearchState } from "../../utils/defaults";

const initialState: ITransferState = {
  ui: {
    modalIsOpen: false
  },
  search: defaultSearchState,
  vendors: {}
};

const transferReducer: Reducer<ITransferState> = (state = initialState, action) => {
  switch (action.type) {
    case TRANSFER_CLEAR:
      return {
        ...state,
        vendors: action.payload.reduce((acc: Dictionary<IVendorState<ITransfer>>, service: string) => {
          acc[service] = {
            items: [],
            status: {
              fetched: false,
              fetching: false,
              error: false
            }
          };
          return acc;
        }, {})
      };

    case `${action.service}_${TRANSFER_FETCH_PENDING}`:
      return {
        ...state,
        vendors: {
          ...state.vendors,
          [action.service]: {
            items: [],
            status: {
              error: false,
              fetched: false,
              fetching: true
            }
          }
        }
      };

    case `${action.service}_${TRANSFER_FETCH_FULFILLED}`:
      return {
        ...state,
        vendors: {
          ...state.vendors,
          [action.service]: {
            items: action.payload,
            status: {
              error: false,
              fetched: true,
              fetching: false
            }
          }
        }
      };

    case `${action.service}_${TRANSFER_FETCH_REJECTED}`:
      return {
        ...state,
        vendors: {
          ...state.vendors,
          [action.service]: {
            items: [],
            status: {
              error: true,
              fetched: true,
              fetching: false
            }
          }
        }
      };

    case `${action.service}_${TRANSFER_FETCH_EMPTY}`:
      return {
        ...state,
        vendors: {
          ...state.vendors,
          [action.service]: {
            items: [],
            status: {
              error: false,
              fetched: true,
              fetching: false
            }
          }
        }
      };
    case TRANSFER_MODAL_OPEN:
      return {
        ...state,
        ui: {
          ...state.ui,
          modalIsOpen: true
        }
      };
    case TRANSFER_MODAL_CLOSE:
      return {
        ...state,
        ui: {
          ...state.ui,
          modalIsOpen: false
        }
      };
    default:
      return state;
  }
};

export default transferReducer;
